<template>
  <div>
    <NewHeader />
    <div class="container mt-4 mb-5">
      <h5 class="text-left font-weight-bold">BRIEF HISTORY OF THE CHURCH</h5>
      <div class="text-justify container">
         <p class="mt-4">The land, about six plots, on which the Church is located, was donated by <strong>Mrs Obiageli Doherty</strong>
        in the early 2000s to the <strong>Archbishop of Lagos, Anthony Cardinal Okogie</strong>.
      </p>

      <p class="mt-2">
        After a period of being a BCC Mass centre, celebrating Mass every 3rd Sunday of the month,
        for members of Ss. Peter and Paul who were residing in Bucknor, it became a full-fledged
        out-station to Ss. Peter and Paul Catholic Church Oke-Afa in <strong>August 2007</strong> with regular Sunday
        Masses after Ss. Peter and Paul became a Parish in July 2007.
      </p>

      <p class="mt-2">
        The pioneer members in the B.C.C Centre toiled very hard to make the premises worthy of its
        status. They cleared the bushes, uprooted tree stumps and swept the grounds and physically
        carried benches from Oke-afa to make the new members comfortable.
      </p>

      <p class="mt-2">
        They were united in heart and mind, prayer and worship. The Spirit continues to date.
        As such the church saw tremendous progress and development. In less than five years of its
        existence as an outstation, population at Sunday Mass was about 1,800 and presently over
        2,500.
      </p>

      <p class="mt-2">
        Under the supervision of the then Parish Priest, <strong>Fr. Sunil Kallarakal, OSJ </strong>, the name Jesus
        the Saviour was picked by <strong>2-year old Uju </strong>, in a spiritual, colourful and memorable Church
        name selection occasion.
      </p>


      <p class="mt-2">
        Fr. Sunil then encouraged the first Church Pastoral Council (CPC) to come on board in April
        2008 as well as be the first Harvest Working Committee. The Harvest was tagged <strong>“Harvest of
        Building for the Lord”</strong>, which held that year, 2008 with <strong>Chief I.O Meregini</strong> as Chairman. We
        have since been celebrating harvest annually with tremendous success.
      </p>

      <p class="mt-2">
        The major immediate and urgent projects of the church were thus the erection of the main
        Church building and the Parish Priest’s house. Upon receiving the Lagos State Government
        approval, while <strong>Fr. Leo Ukwuani OSJ</strong> was parish priest, the Priest’s house foundation was
        laid on the <strong>26th of March 2016 </strong> and was completed in <strong>August 2016</strong>, while the foundation stone
        for the Church was laid in <strong> November 2016</strong> and is still ongoing. The ground floor, the first
        floor decking, the gallery levels and gallery walls have been done awaiting roofing.
      </p>
      <p class="mt-2">
        On the <strong>27th of March 2018</strong>, the Church was pronounced <strong>a Quasi Parish</strong> and subsequently on the
       <strong> 30th of November 2018, Reverend Father Joseph Ozoh’ Nwokeforo</strong> reported as the <strong>first Resident
        Priest</strong>.
      </p>

      <p class="mt-2">
        Other Priests who have worked in the Church include: <strong>Rev. Frs. Sunil Kallarakal OSJ, dory
        Tubesa, OSJ. Jun Sares OSJ, Cornelius Olaniran OSJ, Boniface Ekeowo OSJ, Leo Ukwuani OSJ,
        Anthony Ntia OSJ, and Anthony Agbessime OSJ</strong>. They all toiled in one way or the other, while
        the church was still an outstation of Ss Peter and Paul Catholic Church, Oke-Afa, to see to
        its development.
      </p>

      <p class="mt-2">
        With the coming of the resident Priest-in-Charge, the administration of the church, which we
        now call Parish has moved to a higher level. The Parish Pastoral Council, Parish Finance
        Council and Parish Laity Council are up and running.
      </p>

      <p class="mt-2 pb-5 mb-5">
        Pastoral care is being provided by the Parish Priest, <strong> Rev. Fr. Joseph Ozoh’ Nwokeforo</strong>, with
        the assistance of the <strong> Oblates Sisters of St Joseph</strong> and the Parish Catechist, <strong>Engr. Joseph
        Ajayi Choco</strong>.
      </p>

      </div>

    </div>


    <Footer />
    <BackUp />

  </div>
</template>

<script>
import Footer from '@/components/navigation/Footer.vue';
import NewHeader from '@/components/navigation/NewHeader.vue';
import BackUp from '@/components/BackUp.vue';
// import { INITIAL_EVENTS, createEventId } from './event-utils'
export default {
  components: {
    Footer,
    NewHeader,
    BackUp
  },

}
</script>
